export default "__VITE_ASSET__HDfGvBEb__"